import { Controller } from "@hotwired/stimulus";
// import {Turbo} from "@hotwired/turbo-rails";

/**
 * This Class handles
 *
 * - The SideBar
 * - Backdrop
 * - Implements Hamburguer menu
 */
export default class ShellController extends Controller {
  static targets = ["sidebarLink"];

  connect() {
  }

  toggleMenu() {
    this.element.classList.toggle('open');
  }

  show() {
    this.element.classList.add('open');
  }

  linkClicked(event) {
    // event.stopPropagation();
    // event.preventDefault();
    for (const link of this.sidebarLinkTargets) {
      link.classList.remove('active');
    }

    event.target.classList.add('active');
    // this.hide();
  }

  hide() {
    this.element.classList.remove('open');
  }
}
